$(function() {
  const $banner = $('#js-qr-banner');
  const $closeBtn = $('#js-qr-banner__close');
  const $fv = $('.p-cover');
  let isClosed = false;
  let hasShown = false;

  $closeBtn.on('click', (e) => {
    e.preventDefault();
    $banner.addClass('is-hidden');
    isClosed = true;
  });

  const isPastFirstView = () => {
    if (!$fv.length) {
      return $(window).scrollTop() > $(window).height();
    }
    const fvEnd = Math.min(
      $fv.offset().top + $fv.outerHeight(),
      $(window).height()
    );
    return $(window).scrollTop() >= fvEnd;
  };

  const toggle = () => {
    if (isClosed || hasShown) return;
    if (isPastFirstView()) {
      $banner.addClass('is-visible');
      hasShown = true;
    }
  };

  $(window).on('scroll resize', toggle);
  toggle();
});
